'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PaymentPlansAppIcon = function PaymentPlansAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    width: "81",
    height: "80",
    viewBox: "0 0 81 80"
  }), React__default["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: ".54"
  }, React__default["default"].createElement("path", {
    strokeWidth: "3",
    d: "M48 0L0 0 0 58 8 53 16 58 24 53 32 58 40 53 48 58z",
    transform: "translate(16.5 11)"
  }), React__default["default"].createElement("path", {
    strokeWidth: "2",
    d: "M10 42L26 42M34 42L38 42M10 34L26 34M34 34L38 34M32 18c0 2.858-1.525 5.5-4 6.928-2.475 1.43-5.525 1.43-8 0-2.475-1.429-4-4.07-4-6.928 0-2.858 1.525-5.5 4-6.928 2.475-1.43 5.525-1.43 8 0 2.475 1.429 4 4.07 4 6.928z",
    transform: "translate(16.5 11)"
  })));
};

var PaymentPlansAppIcon$1 = iconStyles()(PaymentPlansAppIcon);

module.exports = PaymentPlansAppIcon$1;
